import React from 'react';
import PropTypes from 'prop-types'

class DefaultLayout extends React.Component {

  renderHeader = () => {
    return (
      <div className="tpl-default__header">
        <div className="container">
          <h1 className="tpl-default__page-title">{this.props.pagetitle}</h1>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="tpl-default">
        {this.props.pagetitle ? this.renderHeader() : null}
        <div className="tpl-default__content">
          {this.props.children}
        </div>
     </div>
    );
  }
}

DefaultLayout.propTypes = {
  pagetitle: PropTypes.string
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/default/index.js